<template>
  <div class="index-down">
    <h2>{{ childItem.propsValue.data.customField2 }}</h2>
    <button>{{ childItem.propsValue.data.customField3.text }}</button>
  </div>
</template>

<script>
let buttonDataObject = {
  text: "立即下载",
  beforeClick: {
    type: 0, // 0 直接访问使用， 1 填写表单后有效
    form: "", // 表单ID，按钮点击需填写表单
    formtime: "无", // 表单有效期  无 一天 七天 永久
  },
  afterClick: {
    type: 1, // 点击后类型  0 无跳转，1 跳转页面  2 关联内容
    url: "",
    contentType: "data", // data 资料， article 文章， video 视频
    contentId: "",
  },
};
export default {
  name: "MkBaipishuWeb",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "图片",
          type: "image",
          width: 1200,
          height: 180,
        },
        {
          code: "customField2",
          label: "白皮书",
          type: "text",
        },
        {
          code: "customField3",
          label: "按钮",
          type: "button",
        },
      ],
      data: {
        customField1:
          "https://mks.yybip.com/group1/M00/08/7D/CgoRC2LVBHaAEKwqAANCym3lTPs181.png",
        customField2: "数智化白皮书和报告",
        customField3: JSON.parse(JSON.stringify(buttonDataObject)),
      },
    };
  },
};
</script>

<style scoped lang="scss">
.index-down {
  background: url(../../../../../assets/img/index-down-bg.png) no-repeat center
    center;
  background-size: auto 183px;
  height: 183px;
  background-color: #e31924;
  box-shadow: 0px 0px 18px 0px rgba(192, 199, 202, 39%);
  border-radius: 6px;
  overflow: hidden;
  z-index: 2;
  text-align: center;

  h2 {
    font-size: 30px;
    line-height: 30px;
    letter-spacing: 1px;
    color: #ffffff;
    padding-top: 40px;
    margin: 0 auto;
  }

  button {
    display: block;
    width: 160px;
    height: 45px;
    line-height: 45px;
    background-image: linear-gradient(
      0deg,
      #ffeaeb 0%,
      #ffffff 100%,
      #91eba4 100%,
      #23d749 100%
    );
    border-radius: 10px;
    border: none;
    font-size: 20px;
    color: #e31924;
    margin: 26px auto 0;
  }
}
</style>
